// src/features/groups/hooks/useGroupPermissions.ts

import { usePermissions } from 'react-admin';
import type { UserRole } from '@/types/models';

interface GroupPermissions {
  canList: boolean;
  canShow: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canViewAll: boolean;
}

/**
 * Hook to get group-specific permissions for the current user
 */
export const useGroupPermissions = (): GroupPermissions => {
  const { permissions } = usePermissions();
  
  // authProvider.getPermissions returns role directly as string
  const role = permissions as UserRole;

  // SuperAdmin has all permissions
  const isSuperAdmin = role === 'SuperAdmin' || role === 'Admin';
  
  // GroupAdmin can view their assigned groups
  const isGroupAdmin = role === 'GroupAdmin';
  
  // HotelAdmin can view groups their hotels belong to
  const isHotelAdmin = role === 'HotelAdmin';

  return {
    canList: isSuperAdmin || isGroupAdmin || isHotelAdmin,
    canShow: isSuperAdmin || isGroupAdmin || isHotelAdmin,
    canCreate: isSuperAdmin,
    canEdit: isSuperAdmin,
    canDelete: isSuperAdmin,
    canViewAll: isSuperAdmin,
  };
};